module.exports = __webpack_public_path__ + "img/search-white.fc472745.svg";